/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.SmsMessageFilter = (function() {

    /**
     * Namespace SmsMessageFilter.
     * @exports SmsMessageFilter
     * @namespace
     */
    var SmsMessageFilter = {};

    SmsMessageFilter.SmsMessageFilterModel = (function() {

        /**
         * Properties of a SmsMessageFilterModel.
         * @memberof SmsMessageFilter
         * @interface ISmsMessageFilterModel
         * @property {string|null} [sortColumn] SmsMessageFilterModel sortColumn
         * @property {string|null} [sortOrder] SmsMessageFilterModel sortOrder
         * @property {number|null} [pageIndex] SmsMessageFilterModel pageIndex
         * @property {number|null} [pageSize] SmsMessageFilterModel pageSize
         */

        /**
         * Constructs a new SmsMessageFilterModel.
         * @memberof SmsMessageFilter
         * @classdesc Represents a SmsMessageFilterModel.
         * @implements ISmsMessageFilterModel
         * @constructor
         * @param {SmsMessageFilter.ISmsMessageFilterModel=} [p] Properties to set
         */
        function SmsMessageFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SmsMessageFilterModel sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof SmsMessageFilter.SmsMessageFilterModel
         * @instance
         */
        SmsMessageFilterModel.prototype.sortColumn = null;

        /**
         * SmsMessageFilterModel sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof SmsMessageFilter.SmsMessageFilterModel
         * @instance
         */
        SmsMessageFilterModel.prototype.sortOrder = null;

        /**
         * SmsMessageFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof SmsMessageFilter.SmsMessageFilterModel
         * @instance
         */
        SmsMessageFilterModel.prototype.pageIndex = null;

        /**
         * SmsMessageFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof SmsMessageFilter.SmsMessageFilterModel
         * @instance
         */
        SmsMessageFilterModel.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * SmsMessageFilterModel _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof SmsMessageFilter.SmsMessageFilterModel
         * @instance
         */
        Object.defineProperty(SmsMessageFilterModel.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * SmsMessageFilterModel _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof SmsMessageFilter.SmsMessageFilterModel
         * @instance
         */
        Object.defineProperty(SmsMessageFilterModel.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * SmsMessageFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof SmsMessageFilter.SmsMessageFilterModel
         * @instance
         */
        Object.defineProperty(SmsMessageFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * SmsMessageFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof SmsMessageFilter.SmsMessageFilterModel
         * @instance
         */
        Object.defineProperty(SmsMessageFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified SmsMessageFilterModel message. Does not implicitly {@link SmsMessageFilter.SmsMessageFilterModel.verify|verify} messages.
         * @function encode
         * @memberof SmsMessageFilter.SmsMessageFilterModel
         * @static
         * @param {SmsMessageFilter.ISmsMessageFilterModel} m SmsMessageFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SmsMessageFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(10).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(18).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(24).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(32).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified SmsMessageFilterModel message, length delimited. Does not implicitly {@link SmsMessageFilter.SmsMessageFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof SmsMessageFilter.SmsMessageFilterModel
         * @static
         * @param {SmsMessageFilter.ISmsMessageFilterModel} message SmsMessageFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SmsMessageFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SmsMessageFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof SmsMessageFilter.SmsMessageFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {SmsMessageFilter.SmsMessageFilterModel} SmsMessageFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SmsMessageFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.SmsMessageFilter.SmsMessageFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.sortColumn = r.string();
                    break;
                case 2:
                    m.sortOrder = r.string();
                    break;
                case 3:
                    m.pageIndex = r.int32();
                    break;
                case 4:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a SmsMessageFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof SmsMessageFilter.SmsMessageFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {SmsMessageFilter.SmsMessageFilterModel} SmsMessageFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SmsMessageFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return SmsMessageFilterModel;
    })();

    return SmsMessageFilter;
})();

module.exports = $root;
